import { lazy } from "react";
import { Navigate, Route } from "react-router-dom";
import MainLayout from "./layouts/main-layout";
import PrivateRoute from "./private-route";
import AffiliateRouteGuard from "../modules/AffiliatePortal/components/AffiliateRouteGuard";

const AffiliateInvoiceLayout = lazy(
  () => import("../common/components/InvoiceLayout/AffiliateInvoiceLayout"),
);
const AffiliatePortalPatients = lazy(
  () => import("../modules/AffiliatePortal/Patients"),
);
const Payments = lazy(() => import("../modules/AffiliatePortal/Payments"));
const AffiliatePortalWrapper = lazy(
  () =>
    import("../modules/EmployerManagement/All Employees/EmployeeMain/Tabs/affiliatePortal"),
);
const EmployeeBasicDetails = lazy(
  () =>
    import("../modules/EmployerManagement/All Employees/EmployeeMain/Tabs/BasicsDetails"),
);
const Agreements = lazy(
  () =>
    import("../modules/Admin/Affiliate/ProvidersAndGroup/Teledoc_health/ChargeCategories/index"),
);
const EmployeeInvoices = lazy(
  () =>
    import("../modules/EmployerManagement/All Employees/EmployeeMain/Tabs/Invoices"),
);
const AffiliatePortalStats = lazy(
  () => import("../modules/AffiliatePortal/Stats"),
);
const AffiliatePortalGuard = lazy(
  () => import("../modules/AffiliatePortal/components/AffiliatePortalGuard"),
);

const MainRoute = () => (
  <PrivateRoute>
    <MainLayout>
      <AffiliatePortalGuard />
    </MainLayout>
  </PrivateRoute>
);

const AffiliatePortalRoutes = (
  <>
    <Route
      path="/affiliate-portal/affiliates/:affiliateGroupUuid"
      element={<MainRoute />}
    >
      {/* <Route path="dashboard" element={<AffiliatePortalDashboard />} /> */}
      <Route
        path="patients"
        element={
          <AffiliateRouteGuard optionPath="patients">
            <AffiliatePortalPatients />
          </AffiliateRouteGuard>
        }
      />
      <Route
        path="patients/:employeeUuid"
        element={
          <AffiliateRouteGuard optionPath="patients">
            <AffiliatePortalWrapper />
          </AffiliateRouteGuard>
        }
      >
        <Route index element={<Navigate to="employee-details" replace />} />
        <Route
          path="employee-details"
          element={<EmployeeBasicDetails feature="Admin Affiliate Patients" />}
        />
        <Route
          path="invoices"
          element={<EmployeeInvoices feature="Billing Employee Invoices" />}
        />
      </Route>
      <Route
        path="payments"
        element={
          <AffiliateRouteGuard optionPath="payments">
            <Payments />
          </AffiliateRouteGuard>
        }
      />
      <Route
        path="notifications"
        element={
          <AffiliateRouteGuard optionPath="notifications">
            <>Notifications</>
          </AffiliateRouteGuard>
        }
      />
      <Route
        path="settings"
        element={
          <AffiliateRouteGuard optionPath="settings">
            <Agreements />
          </AffiliateRouteGuard>
        }
      ></Route>

      <Route
        path="dashboard"
        element={
          <AffiliateRouteGuard optionPath="dashboard">
            <AffiliatePortalStats />
          </AffiliateRouteGuard>
        }
      />
    </Route>
    <Route element={<MainRoute />}>
      <Route
        path="/affiliate-portal/affiliates/:affiliateUuid/invoice/:invoiceUuid/:mode?"
        element={
          <AffiliateRouteGuard optionPath="payments">
            <AffiliateInvoiceLayout />
          </AffiliateRouteGuard>
        }
      />
    </Route>
  </>
);

export default AffiliatePortalRoutes;
